<template>
  <div class="nitrogen">
    <p v-if="firstConnection">{{ $ml.get('Before get a result, please,  Insert the Nitrogen (Kg/ha) applied') }}</p>
    <p v-else>{{ $ml.get(`You can change Nitrogen (Kg/ha) applied here`) }}:</p>
    <app-number-input v-model="N" :min="0" :max="1000"></app-number-input>
    <app-btn @click="connectNitrogen" :disabled="!N || N < 0">{{ $ml.get('Save') }}</app-btn>
    <nitrogen-legend />
  </div>
</template>

<script>
import NitrogenLegend from '@/components/satellite/legend/NitrogenLegend'
import API from '@/api'

export default {
  props: {
    firstConnection: {
    }
  },
  data() {
    return {
      N: 0,

    }
  },
  created() {
    this.N = this.$store.getters['satellite/nitrogenAmount'];
    console.log(this.N);
  },
  methods: {
    connectNitrogen() {
      if(this.firstConnection) {
        return API.satellite.connectNitrogen(this.$store.getters['satellite/fieldInfo'].id, this.N).then(res => {
          this.$emit('fetch');
        })
      } else {
        return API.satellite.connectNitrogen(this.$store.getters['satellite/fieldInfo'].id, this.N).then(res => {
          this.$emit('fetch');
        })
      }


    },

  },
  components: {
    NitrogenLegend,
  }
}
</script>

<style lang="scss" scoped>
.nitrogen {
  button {
    margin-top: 24px;
  }
}
</style>
